<div class="row wrapper border-bottom white-bg page-heading">
  <div class="row">
    <div class="col-lg-12">
        <div class="card product-detail bg-emphasis bg-opacity-30">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">

                <img class="logo" src="/assets/images/cerestag.png"/>

              </div>
              <div class="col-md-8 p-2">

                <h4 class="h5">Product description</h4>

                <div class="mt-2">
                  Ceres Tag is the world’s first animal monitoring, direct to satellite capability through a smart ear tag. Ceres Tag uses data collection and on-tag analytics to provide animal-specific location, movement and animal health monitoring.
                </div>
                
                <div class="mt-2">
                  Need help with your tags? Contact <a href="mailto:info@cerestag.com">info@cerestag</a> and one of our team members can lend a hand.                          
                </div>

                <div class="btn-group mt-4">
                    <button class="btn btn-primary btn-sm" *ngIf="application == null" (click)="enable()"><i class="fa fa-cart-plus"></i> Activate Feature</button>
                    &nbsp;
                    <a class="btn btn-white btn-sm" href="https://www.cerestag.com/buy-ceres-tags/" target="_blank"><i class="fa fa-star"></i> Buy Ceres Tags</a>
                </div>

              </div>                    
            </div>
            <div class="row">
              <div class="col-md-6">

                <div *ngIf="application && application.applicationConfiguration">
                  <div>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Activated by:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{application.activatedBy}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Activated date:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{application.activatedDate}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                      <div class="col-sm-4 text-sm-right">
                          <dt>Client ID:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">{{application.applicationConfiguration.clientId}}</dd>
                      </div>
                    </dl>
                  </div>
                </div>

              </div>
              <div class="col-md-6">

                <div *ngIf="application && application.applicationConfiguration">
                  <div>
                   
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Farms:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{application.applicationConfiguration.farms.length}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                      <div class="col-sm-4 text-sm-right">
                          <dt>Status:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">
                          <span *ngIf="application.applicationConfiguration.connected" class="label label-success">Active</span>
                          <span *ngIf="!application.applicationConfiguration.connected" class="label label-danger">Pending</span>
                        </dd>
                      </div>
                    </dl>
                    <dl class="row mb-0" >
                      <div class="col-sm-4 text-sm-right">
                          <dt>Onboarding:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">
                          <a *ngIf="!application.applicationConfiguration.connected" href="https://manage.cerestag.com/property/setup">Login to CeresTag to complete onboarding process</a>
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>

              </div>
            </div>
          </div>
          
          <!-- card-arrow -->
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
    </div>
  </div>  

  <div class="row mt-4" *ngIf="config">
    <div class="col-lg-12">
      <div class="card product-detail">
        <div class="card-header bg-emphasis bg-opacity-20">
          <div class="input-group">
            <input type="text" placeholder="Enter Name" class="form-control form-control-sm" [(ngModel)]="newFarmName" required/>
            <span class="input-group-append">
              <button class="button btn btn-sm btn-primary" (click)="addFarm()">Add Farm</button>
            </span>  
          </div>
        </div>
        <div class="card-body bg-emphasis bg-opacity-15">
          
          <table class="table table-striped" >
            <thead>
            <tr>
                <th>#</th>
                <th>Name</th>
                <th class="d-none d-sm-table-cell">Identifier</th>
                <th class="d-none d-sm-table-cell">Processing</th>
            </tr>
            </thead>
            <tbody >
            <tr *ngFor="let farm of config.farms; let i = index" [attr.data-index]="i">
              <td>{{i}}</td>
              <td>{{farm.displayName}}</td>
              <td class="d-none d-sm-table-cell">{{farm.identifier}}</td>
              <td class="d-none d-sm-table-cell">
                <button (click)="activeIndiciumCloud(farm)" *ngIf="!farm.setupInCloud && application.applicationConfiguration.connected" class="btn btn-xs btn-theme"><i class="fa fa-cloud"></i> Setup INDICIUM Cloud</button>
                <span *ngIf="farm.setupInCloud">INDICIUM Cloud Enabled</span>
              </td>
              <td>
                <div>
                  <a class="btn btn-xs btn-outline-primary" title="View Farm" *ngIf="farm.setupInCloud && application.applicationConfiguration.connected" [routerLink]="'/application/ceres-tag/farm/' + app.customerId + '/' + farm.identifier"><i class="fa fa-globe"></i></a>
                  <button class="btn btn-xs btn-outline-danger" (click)="deleteFarm(farm)"><i class="fa fa-trash"></i></button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
          <!-- card-arrow -->
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
      </div>
    </div>
  </div>    
</div>
